import WorkspaceEvaluation from "../../WorkspaceEvaluation"
import RemoteEvaluateClient from "../../client/RemoteEvaluateClient"
import { PartialWorkspaceEvaluateRequest } from "./PartialWorkspaceEvaluateRequest"
import { PartialWorkspaceEvaluateResponse } from "./PartialWorkspaceEvaluateResponse"
import WorkspaceRemoteEvaluator from "../WorkspaceRemoteEvaluator"

/**
 * Evaluates a specific set of entities (partial). Structural only for now — the browser client does
 * not yet consume entity-level evaluation (deferred to the expansion phase).
 */
export default class PartialWorkspaceRemoteEvaluator
  implements WorkspaceRemoteEvaluator<PartialWorkspaceEvaluateRequest, PartialWorkspaceEvaluateResponse>
{
  constructor(private readonly client: RemoteEvaluateClient) {}

  async evaluate(request: PartialWorkspaceEvaluateRequest): Promise<PartialWorkspaceEvaluateResponse> {
    const response = await this.client.evaluateEntities(request.toDto())
    return new PartialWorkspaceEvaluateResponse(WorkspaceEvaluation.from(response.evaluation))
  }
}
